import { IFactService } from "../../service/evaluation/FactService";
import { IFact } from "../../model/evaluation/Fact";

export default class UpdateFactInteractor {
  private factService: IFactService;

  constructor(factService) {
    this.factService = factService;
  }

  async execute(fact: IFact) {
    return this.factService.updateFact(fact);
  }
}
